import moment from 'moment';

var tiz_date = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'N/A'; }
    try {
      var d = new Date(input);
    } catch(err) {
      return 'N/A';
    }
    var timezone = d.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
    return moment(d).format('lll') + ' ' + timezone;
  };
};
tiz_date.$inject = [];
tiz.filter('tiz_date', tiz_date);

var tiz_date_preserve_zone = function() {
  return function(input) {
    if (moment.isMoment(input)){
      return input.format('lll z')
    } else {
      return tiz_date(input)
    }
  };
};
tiz_date_preserve_zone.$inject = [];
tiz.filter('tiz_date_preserve_zone', tiz_date_preserve_zone);

var filter2 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'N/A'; }
    try {
      var d = new Date(input);
    } catch(err) {
      return 'N/A';
    }
    return moment(d).format('MMM DD, YYYY');
  };
};

filter2.$inject = [];

tiz.filter('tiz_date_notime', filter2);

var filter3 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'N/A'; }
    return moment(input, 'HH:mm:ss').format('hh:mm a');
  };
};

filter3.$inject = [];

tiz.filter('tiz_date_only_time', filter3);

var filter4 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'N/A'; }
    return moment.utc(input).format('dddd, MMMM D');
  };
};

var daysAgo = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'N/A'; }
    try {
      var d = new Date(input);
    } catch(err) {
      return '--';
    }
    var daysAgo = moment().diff(moment(d), 'days')
    if (daysAgo == 0) { return 'Today'; }
    if (daysAgo < 0) { return daysAgo * -1 + ' days from now'; }
    return daysAgo + ' days ago';
  };
};
daysAgo.$inject = [];
tiz.filter('daysAgo', daysAgo);


filter4.$inject = [];

tiz.filter('tiz_delivery_date', filter4);

const noDateNoTimeNoTz = function(input) {
  if (input == null || input == undefined || input == 0) { return 'N/A'; }
  return moment(input).format('MMM DD, YYYY');
}

var filter5 = function() {
  return function(input) {
    return noDateNoTimeNoTz(input)
  }
};

filter5.$inject = [];
tiz.filter('tiz_date_notime_notz', filter5);

var hourMinuteMeridiemTime = function() {
  return function(time) {
    if (time == null || time == undefined || time == '') { return ''; }
    return moment('01-01-2000 ' + time, "MM-DD-YYYY HH:mm:ss").format('h:mmA')
  };
};
hourMinuteMeridiemTime.$inject = [];
tiz.filter('provi_hr_min_meridiem_time', hourMinuteMeridiemTime);

var timeZoneAbbr = function() {
  return function(tz_name) {
    if (tz_name == null || tz_name == undefined || tz_name == '') { return ''; }
    return new Date().toLocaleString("en-US", {timeZone: tz_name, timeZoneName: "short"}).split(' ').pop();
  };
};
timeZoneAbbr.$inject = [];
tiz.filter('provi_time_zone_abbr', timeZoneAbbr);

export default {
  noDateNoTimeNoTz: noDateNoTimeNoTz,
  dateNoTime: filter2,
  tiz_date: tiz_date
}
